/* ============================================================
   THEME.JS — La Bijouterie d'Emilie
   Version propre — une seule implémentation de chaque feature
   ============================================================ */
(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════
     1. SEARCH OVERLAY
  ═══════════════════════════════════════════════════════════ */
  var searchOverlay = document.getElementById('search-overlay');
  var searchClose   = document.getElementById('search-close');

  document.getElementById('search-toggle')?.addEventListener('click', function () {
    searchOverlay?.classList.add('is-open');
    searchOverlay?.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { searchOverlay?.querySelector('input')?.focus(); }, 80);
  });
  searchClose?.addEventListener('click', closeSearch);
  searchOverlay?.addEventListener('click', function (e) { if (e.target === searchOverlay) closeSearch(); });

  function closeSearch() {
    searchOverlay?.classList.remove('is-open');
    searchOverlay?.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ═══════════════════════════════════════════════════════════
     2. MOBILE MENU
  ═══════════════════════════════════════════════════════════ */
  var mobileMenu  = document.getElementById('mobile-menu');
  var siteOverlay = document.getElementById('site-overlay');

  if (siteOverlay) {
    siteOverlay.style.cssText =
      'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:399;' +
      'opacity:0;visibility:hidden;transition:opacity .3s,visibility .3s;cursor:pointer;';
  }

  document.getElementById('hamburger-btn')?.addEventListener('click', openMenu);
  document.getElementById('mobile-close')?.addEventListener('click', closeMenu);
  siteOverlay?.addEventListener('click', function () { closeMenu(); closeWishlistDrawer(); });

  function openMenu() {
    mobileMenu?.classList.add('is-open');
    document.getElementById('hamburger-btn')?.setAttribute('aria-expanded', 'true');
    showOverlay();
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileMenu?.classList.remove('is-open');
    document.getElementById('hamburger-btn')?.setAttribute('aria-expanded', 'false');
    hideOverlay();
    document.body.style.overflow = '';
  }
  function showOverlay() {
    if (siteOverlay) { siteOverlay.style.opacity = '1'; siteOverlay.style.visibility = 'visible'; }
  }
  function hideOverlay() {
    // Only hide if no drawer is open
    var drawerOpen = document.getElementById('wl-drawer')?.classList.contains('is-open');
    if (!drawerOpen && siteOverlay) {
      siteOverlay.style.opacity = '0';
      siteOverlay.style.visibility = 'hidden';
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeSearch();
    closeMenu();
    closeWishlistDrawer();
  });

  /* ═══════════════════════════════════════════════════════════
     3. STICKY / TRANSPARENT HEADER
  ═══════════════════════════════════════════════════════════ */
  var header  = document.getElementById('SiteHeader');
  var isHome  = document.body.classList.contains('template-index');
  var lastY   = 0;

  window.addEventListener('scroll', function () {
    var y = window.scrollY;
    if (isHome) {
      var heroH = document.querySelector('.hero-video-wrap')?.offsetHeight || window.innerHeight;
      header?.classList.toggle('header--scrolled', y > heroH * 0.3);
    } else if (header) {
      if (y > 80) {
        header.classList.add('header--scrolled');
        header.classList.toggle('header--hidden', y > lastY && y > 300);
      } else {
        header.classList.remove('header--scrolled', 'header--hidden');
      }
    }
    lastY = y;
  }, { passive: true });

  /* ═══════════════════════════════════════════════════════════
     4. HERO VIDEO — pause si onglet caché
  ═══════════════════════════════════════════════════════════ */
  var heroVideo = document.querySelector('.hero-video__player');
  if (heroVideo) {
    document.addEventListener('visibilitychange', function () {
      document.hidden ? heroVideo.pause() : heroVideo.play().catch(function(){});
    });
  }

  /* ═══════════════════════════════════════════════════════════
     5. PRODUCT GALLERY v2 (page produit)
  ═══════════════════════════════════════════════════════════ */
  document.querySelectorAll('.product-gallery-v2__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.product-gallery-v2__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var img = document.getElementById('gallery-main-img');
      if (!img || !thumb.dataset.src) return;
      img.style.opacity = '0';
      setTimeout(function () { img.src = thumb.dataset.src; img.style.opacity = '1'; }, 200);
    });
  });

  /* ═══════════════════════════════════════════════════════════
     6. PRODUCT ACCORDIONS
  ═══════════════════════════════════════════════════════════ */
  document.querySelectorAll('.product-accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.product-accordion__trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        t.nextElementSibling?.classList.remove('is-open');
      });
      if (!open) {
        trigger.setAttribute('aria-expanded', 'true');
        trigger.nextElementSibling?.classList.add('is-open');
      }
    });
  });

  /* ═══════════════════════════════════════════════════════════
     7. FAQ ACCORDIONS
  ═══════════════════════════════════════════════════════════ */
  document.querySelectorAll('.faq-item__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.faq-item__trigger').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        t.nextElementSibling?.classList.remove('is-open');
      });
      if (!open) {
        trigger.setAttribute('aria-expanded', 'true');
        trigger.nextElementSibling?.classList.add('is-open');
      }
    });
  });

  /* ═══════════════════════════════════════════════════════════
     8. WISHLIST — localStorage + drawer
     Clé : 'swv_wishlist'  (tableau de handles produits)
  ═══════════════════════════════════════════════════════════ */
  var WL_KEY = 'swv_wishlist';

  function wlGet()      { try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch(e) { return []; } }
  function wlSave(arr)  { localStorage.setItem(WL_KEY, JSON.stringify(arr)); }
  function wlHas(h)     { return wlGet().indexOf(h) !== -1; }

  function wlToggle(handle) {
    var list = wlGet();
    var idx  = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else            list.splice(idx, 1);
    wlSave(list);
    wlUpdateBadge(list.length);
    return idx === -1; // true = ajouté
  }

  function wlUpdateBadge(n) {
    var badge = document.getElementById('wishlist-count');
    if (!badge) return;
    badge.textContent = n;
    badge.style.display = n > 0 ? 'flex' : 'none';
  }

  /* ── Initialiser les cœurs sur toutes les cartes / page produit ── */
  function wlInitButtons() {
    wlUpdateBadge(wlGet().length);

    document.querySelectorAll(
      '.product-card__wishlist[data-handle], .product-gallery-v2__wishlist[data-handle]'
    ).forEach(function (btn) {
      var handle = btn.dataset.handle;
      if (!handle) return;

      // État initial
      var liked = wlHas(handle);
      setHeartState(btn, liked);

      // Clic
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var added = wlToggle(handle);
        setHeartState(btn, added);
        // Micro-animation
        btn.style.transform = 'scale(1.4)';
        setTimeout(function () { btn.style.transform = 'scale(1)'; }, 220);
      });
    });
  }

  function setHeartState(btn, liked) {
    btn.classList.toggle('is-wished', liked);
    var svg = btn.querySelector('svg');
    if (svg) svg.setAttribute('fill', liked ? 'currentColor' : 'none');
  }

  /* ── WISHLIST DRAWER ── */
  var wlDrawer = null;

  function openWishlistDrawer() {
    wlDrawer = wlDrawer || document.getElementById('wl-drawer');
    if (!wlDrawer) return;
    wlDrawer.classList.add('is-open');
    wlDrawer.setAttribute('aria-hidden', 'false');
    showOverlay();
    document.body.style.overflow = 'hidden';
    wlRenderDrawer();
  }
  function closeWishlistDrawer() {
    wlDrawer = wlDrawer || document.getElementById('wl-drawer');
    wlDrawer?.classList.remove('is-open');
    wlDrawer?.setAttribute('aria-hidden', 'true');
    if (siteOverlay) { siteOverlay.style.opacity = '0'; siteOverlay.style.visibility = 'hidden'; }
    document.body.style.overflow = '';
  }
  window.closeWishlistDrawer = closeWishlistDrawer;
  window.openWishlistDrawer  = openWishlistDrawer;

  document.getElementById('wishlist-trigger')?.addEventListener('click', openWishlistDrawer);
  document.getElementById('wishlist-trigger-mobile')?.addEventListener('click', openWishlistDrawer);
  document.getElementById('wl-drawer-close')?.addEventListener('click', closeWishlistDrawer);

  function wlRenderDrawer() {
    var elItems   = document.getElementById('wl-drawer-items');
    var elLoading = document.getElementById('wl-drawer-loading');
    var elEmpty   = document.getElementById('wl-drawer-empty');
    if (!elItems) return;

    var handles = wlGet();
    elItems.innerHTML    = '';
    elItems.style.display   = 'none';
    elLoading.style.display = 'flex';
    elEmpty.style.display   = 'none';

    if (handles.length === 0) {
      elLoading.style.display = 'none';
      elEmpty.style.display   = 'flex';
      return;
    }

    var done = 0;
    var rows = new Array(handles.length);

    handles.forEach(function (handle, i) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { rows[i] = p ? wlBuildRow(p) : null; })
        .catch(function ()  { rows[i] = null; })
        .finally(function () {
          done++;
          if (done < handles.length) return;
          elLoading.style.display = 'none';
          var html = rows.filter(Boolean).join('');
          if (html) {
            elItems.innerHTML     = html;
            elItems.style.display = 'flex';
          } else {
            elEmpty.style.display = 'flex';
          }
        });
    });
  }

  function wlFmt(cents) {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function wlBuildRow(p) {
    var img = p.featured_image
      ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2')
      : '';
    return '<div class="wl-item" data-handle="' + p.handle + '">'
      + '<a href="/products/' + p.handle + '" class="wl-item__img-link" onclick="closeWishlistDrawer()">'
      + (img ? '<img src="' + img + '" alt="' + p.title + '" class="wl-item__img" loading="lazy">'
             : '<div class="wl-item__img-placeholder"></div>')
      + '</a>'
      + '<div class="wl-item__info">'
      + '<a href="/products/' + p.handle + '" class="wl-item__title" onclick="closeWishlistDrawer()">' + p.title + '</a>'
      + '<p class="wl-item__price">' + wlFmt(p.price) + '</p>'
      + '<button class="wl-item__add" type="button" onclick="wlAddToCart(' + p.variants[0].id + ',this)">Ajouter au panier</button>'
      + '</div>'
      + '<button class="wl-item__remove" type="button" onclick="wlRemoveRow(\'' + p.handle + '\')" aria-label="Retirer">'
      + '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      + '</button>'
      + '</div>';
  }

  window.wlRemoveRow = function (handle) {
    wlToggle(handle); // enlève du localStorage
    // Sync cœurs sur la page
    document.querySelectorAll('[data-handle="' + handle + '"]').forEach(function (btn) {
      if (btn.classList.contains('product-card__wishlist') ||
          btn.classList.contains('product-gallery-v2__wishlist')) {
        setHeartState(btn, false);
      }
    });
    // Animer la suppression dans le drawer
    var row = document.querySelector('.wl-item[data-handle="' + handle + '"]');
    if (row) {
      row.style.transition = 'opacity .25s, transform .25s';
      row.style.opacity    = '0';
      row.style.transform  = 'translateX(30px)';
      setTimeout(function () {
        row.remove();
        if (!document.querySelector('.wl-item')) {
          document.getElementById('wl-drawer-items').style.display = 'none';
          document.getElementById('wl-drawer-empty').style.display = 'flex';
        }
      }, 270);
    }
  };

  window.wlAddToCart = function (variantId, btn) {
    btn.textContent = '…';
    btn.disabled    = true;
    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function () {
      btn.textContent = '✓ Ajouté !';
      // Mettre à jour le compteur du panier
      return fetch('/cart.js');
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var countEl = document.querySelector('.cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.style.display = cart.item_count > 0 ? 'flex' : 'none';
      }
      setTimeout(function () { btn.textContent = 'Ajouter au panier'; btn.disabled = false; }, 2000);
    })
    .catch(function () { btn.textContent = 'Erreur'; setTimeout(function () { btn.textContent = 'Ajouter au panier'; btn.disabled = false; }, 1500); });
  };

  /* ═══════════════════════════════════════════════════════════
     9. SCROLL ANIMATIONS
  ═══════════════════════════════════════════════════════════ */
  function initAnimations() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.anim-item,.anim-single,.anim-from-right,.anim-title')
        .forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    /* Grilles — gauche → droite */
    var gridObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var items = entry.target.querySelectorAll('.anim-item');
        var cols  = getComputedStyle(entry.target).gridTemplateColumns.split(' ').length || 4;
        items.forEach(function (item, i) {
          item.style.transitionDelay = (i % cols * 110 + Math.floor(i / cols) * 55) + 'ms';
          requestAnimationFrame(function () { requestAnimationFrame(function () { item.classList.add('is-visible'); }); });
        });
        gridObs.unobserve(entry.target);
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.product-grid, .category-grid__grid, .services-grid, .coll-showcase__grid').forEach(function (grid) {
      grid.querySelectorAll('.product-card,.category-card,.service-item,.coll-showcase__card').forEach(function (c) { c.classList.add('anim-item'); });
      gridObs.observe(grid);
    });

    /* Photos uniques — scale depuis le fond */
    var singleObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        requestAnimationFrame(function () { requestAnimationFrame(function () { entry.target.classList.add('is-visible'); }); });
        singleObs.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.editorial-split').forEach(function (s) {
      s.querySelector('.editorial-split__media')?.classList.add('anim-single');
      s.querySelector('.editorial-split__content')?.classList.add('anim-from-right');
    });
    document.querySelectorAll(
      '.collection-hero__bg, .product-gallery-v2, ' +
      '.newsletter-section__image, .newsletter-section__content, .product-info-panel'
    ).forEach(function (el) {
      el.classList.add(el.classList.contains('newsletter-section__content') || el.classList.contains('product-info-panel') ? 'anim-from-right' : 'anim-single');
    });
    document.querySelectorAll('.anim-single, .anim-from-right').forEach(function (el) { singleObs.observe(el); });

    /* Titres */
    var titleObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        requestAnimationFrame(function () { requestAnimationFrame(function () { entry.target.classList.add('is-visible'); }); });
        titleObs.unobserve(entry.target);
      });
    }, { threshold: 0.4 });
    document.querySelectorAll('.section-title, .collection-hero__title, .collection-hero__eyebrow').forEach(function (el) {
      el.classList.add('anim-title'); titleObs.observe(el);
    });

    /* FAQ stagger */
    var faqObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.querySelectorAll('.faq-item').forEach(function (item, i) {
          item.style.cssText = 'opacity:0;transform:translateY(16px);transition:opacity .5s ' + i*80 + 'ms ease,transform .5s ' + i*80 + 'ms ease;';
          requestAnimationFrame(function () { requestAnimationFrame(function () { item.style.opacity='1'; item.style.transform='translateY(0)'; }); });
        });
        faqObs.unobserve(entry.target);
      });
    }, { threshold: 0.05 });
    document.querySelectorAll('.faq-list').forEach(function (l) { faqObs.observe(l); });
  }

  /* ═══════════════════════════════════════════════════════════
     INIT — après chargement du DOM
  ═══════════════════════════════════════════════════════════ */
  function init() {
    wlInitButtons();
    initAnimations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
